import * as Yup from "yup";

export const PartnerDetailsSchema = (t) =>
	Yup.object({
		insuranceAmount: Yup.string().required(t("validationMsg.fieldRequired")),
		insuranceNumber: Yup.string().required(t("validationMsg.fieldRequired")),
		insuranceStartDate: Yup.string().required(t("validationMsg.fieldRequired")),
		insuranceExpireDate: Yup.string().required(t("validationMsg.fieldRequired"))
	});
